import React from 'react';
import './Pricing.scss';
import { CONTACTS } from '../../config/contacts';

const Pricing: React.FC = () => {
  const plans = [
    {
      id: 1,
      name: 'Core',
      price: null,
      period: '',
      description: 'Sistema completo com módulos padrão + módulos premium',
      features: [
        'Todos os módulos padrão',
        'Até 4 módulos premium',
        'Treinamento + onboarding guiado',
        'Implantação colaborativa',
        'Grupo exclusívo no WhatsApp para dúvidas e suporte',
      ],
      highlighted: false,
      isWhatsApp: true,
      setupFee: false,
      cta: 'Falar com especialista',
      ctaLink: CONTACTS.whatsapp.getUrl('Olá, gostaria de saber mais sobre o plano Core'),
    },
    {
      id: 2,
      name: 'Plus',
      price: null,
      period: '',
      description: 'Automação avançada e dashboards personalizados',
      features: [
        'Tudo do plano Core',
        'Até 8 módulos premium',
        'Bot WhatsApp integrado',
        'Dashboards customizados',
        'Até 20 usuários'
      ],
      highlighted: true,
      cta: 'Falar com especialista',
      ctaLink: CONTACTS.whatsapp.getUrl('Olá, gostaria de saber mais sobre o plano Plus'),
      isWhatsApp: true,
      setupFee: false,
      badge: 'Recomendado'
    },
    {
      id: 3,
      name: 'Enterprise',
      price: null,
      period: '',
      description: 'Plano personalizado para necessidades do seu negócio',
      features: [
        'Tudo do plano Plus',
        'Criação de módulos personalizados para seu negócio',
        'Integração com outros sistemas',
        'Assistente financeiro virtual',
        'Evolução continua'
      ],
      highlighted: false,
      cta: 'Falar com especialista',
      ctaLink: CONTACTS.whatsapp.getUrl('Olá, gostaria de saber mais sobre o plano Enterprise'),
      isWhatsApp: true
    }
  ];

  return (
    <section id="precos" className="pricing">
      <div className="pricing-container">
        <div className="pricing-header">
          <h2>Planos para cada fase do seu negócio</h2>
          <p>Escolha o plano ideal e fale com um especialista para receber uma proposta personalizada</p>
        </div>

        <div className="plans-grid">
          {plans.map((plan) => (
            <div 
              key={plan.id} 
              className={`plan-card ${plan.highlighted ? 'plan-highlighted' : ''}`}
            >
              {plan.badge && (
                <div className="plan-badge">{plan.badge}</div>
              )}
              
              <div className="plan-header">
                <h3>{plan.name}</h3>
                <div className="plan-price">
                  {plan.price ? (
                    <>
                      <span className="currency">R$</span>
                      <span className="amount">{plan.price}</span>
                      <span className="period">{plan.period}</span>
                    </>
                  ) : (
                    <span className="custom-price"></span>
                  )}
                </div>
                {plan.setupFee && (
                  <p className="setup-fee">+ taxa de setup única</p>
                )}
                <p className="plan-description">{plan.description}</p>
              </div>

              <ul className="plan-features">
                {plan.features.map((feature, index) => (
                  <li key={index}>
                    <i className="fas fa-check"></i>
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>

              <a 
                href={plan.ctaLink} 
                className={`plan-cta ${plan.highlighted ? 'cta-highlighted' : ''}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                {plan.isWhatsApp && <i className="fab fa-whatsapp"></i>}
                {plan.cta}
              </a>
            </div>
          ))}
        </div>

        <div className="pricing-footer">
          <p>Todos os planos incluem <strong>suporte dedicado</strong> e implantação guiada</p>
          <a href="/funcionalidades" className="compare-link">
            Confira as funcionalidades <i className="fas fa-arrow-right"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
